import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    mainWrapper: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: theme.palette.primary.main,
        textTransform: "uppercase",
        padding: "2px 4px",
        lineHeight: "1.1",
        borderRadius: "2px",
    },
    small: {
        fontSize: "10px",
    },
    info: {
        backgroundColor: theme.palette.info.main,
    },
    error: {
        backgroundColor: theme.palette.error.main,
    },
    warning: {
        backgroundColor: theme.palette.warning.main,
    },
    success: {
        backgroundColor: theme.palette.success.main,
    },
}));
